import { get, patch } from '../../utils/http';

export const fetchAccountOrders = ({ accountId }) => get(`/accounts/${accountId}/orders`);

export const updateOrder = ({ accountId, orderId, status, documents, cancellationReason, sessionNumber }) =>
  patch(`/accounts/${accountId}/orders/${orderId}`, { status, documents, cancellationReason, sessionNumber });

export const fetchOrderDetails = ({ accountId, orderId }) => get(`/accounts/${accountId}/orders/${orderId}`);

export const getOrderCurrentSessionNumber = ({ accountId, orderId }) =>
  get(`/accounts/${accountId}/orders/${orderId}/session-number`);

export const fetchSupplierAccountOrderStats = ({ accountId }) => get(`/accounts/${accountId}/orders/stats`);
